import React from 'react'
import { observer } from 'mobx-react-lite'
import { Spacer } from '../../../../ui/atoms'
import RadioButton from '@linqpal/common-frontend/src/ui/RadioButton'
import { View, Text, StyleSheet } from 'react-native'
import { AppInputDynamicPadding } from '../../../../ui/molecules'
import { useTranslation } from 'react-i18next'
import { ICardEntryModel } from '@linqpal/models'
import { EAccountType } from '@linqpal/models/src/dictionaries'
import { BtButton } from '@linqpal/components/src/ui'

interface CardholderDetailsProps {
  onAction: () => void
  model: ICardEntryModel
}

export const CardholderDetails: React.FC<CardholderDetailsProps> = observer(
  ({ onAction, model }) => {
    const { t } = useTranslation('global')
    return (
      <View style={styles.rootView}>
        <Text style={styles.accountType}>{t('AddCard.account-type')}</Text>
        <View style={styles.radioWrapper}>
          <RadioButton
            label={t('AddCard.personal-account')}
            checked={model.accountType === EAccountType.PERSONAL}
            onPress={() => {
              model.setValue('accountType', EAccountType.PERSONAL)
              model.setValue('lastName', '')
            }}
          />
          <RadioButton
            label={t('AddCard.business-account')}
            checked={model.accountType === EAccountType.BUSINESS}
            onPress={() => {
              model.setValue('accountType', EAccountType.BUSINESS)
              model.setValue('lastName', 'LLC')
            }}
          />
        </View>
        <AppInputDynamicPadding
          label={
            model.accountType === EAccountType.PERSONAL
              ? (t('AddCard.first-name') as string)
              : (t('AddCard.name-on-card') as string)
          }
          model={model}
          name="firstName"
          mandatory
        />
        {model.accountType === EAccountType.PERSONAL ? (
          <AppInputDynamicPadding
            label={t('AddCard.last-name') as string}
            model={model}
            name="lastName"
            mandatory
          />
        ) : null}
        <Spacer height={16} />
        <BtButton
          block
          onPress={() => onAction()}
          disabled={!model.nameFilled}
          wrapperStyle={null}
        >
          {t('AddCard.next')}
        </BtButton>
      </View>
    )
  },
)

export default {
  title: 'Enter name on the card',
  component: CardholderDetails,
  next: 'AddressDetails',
  previous: 'Manual',
}

const styles = StyleSheet.create({
  rootView: {
    marginTop: 38,
  },
  accountType: {
    fontSize: 16,
    fontWeight: '600',
    color: '#3E4756',
  },
  radioWrapper: {
    flexDirection: 'column',
    marginTop: 8,
  },
})
